import React, { useEffect, useState, useRef, useCallback } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import {
  CommunityPost_Like,
  CommunityPost_UnLike,
  Delete_post,
  GetAllPost,
} from "../../../actions/auth";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  MY_PROFILE,
  MY_PROFILE_COMMUNITY,
  MY_PROFILE_COMMUNITY_POST,
} from "../../../actions/types";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import ModalPostCommunity from "./ModalPostCommunity";
import Spinner from "../Spinner";
import Heart from "../../../assests/24 Heart.gif";

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

const GetAllPosts = () => {
  const [list, setList] = useState([]); // State to hold API data
  const [loadingData, setLoadingData] = useState(false);
  const [sliderImages, setSliderImages] = useState([]); // State for slider images
  const [isSliderOpen, setIsSliderOpen] = useState(false); // State to toggle slider
  const [page, setPage] = useState(1); // Current page
  const [hasMore, setHasMore] = useState(true); // State to check if more posts are available
  const observerRef = useRef(); // Ref for the intersection observer
  const location = useLocation();
  const { state } = location;

  const dispatch = useDispatch("");

  // Add new state for tracking which post is being liked
  const [likeInProgress, setLikeInProgress] = useState(null);

  const handlePageChange = debounce(() => {
    setPage((prevPage) => prevPage + 1);
  }, 500);

  const fetchPosts = async (pageNum) => {
    setLoadingData(true);

    try {
      const response = await dispatch(GetAllPost(pageNum, 5, state?._id));
      if (response?.success) {
        // Only update hasMore if we received less data than requested
        setHasMore(response.data.length === 5); // Since we request 5 items

        setList((prevList) => {
          const updatedList =
            pageNum === 1 ? response.data : [...prevList, ...response.data];
          return updatedList;
        });
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoadingData(false);
    }
  };
  useEffect(() => {
    fetchPosts(page);
  }, [page]);

  const lastPostRef = useCallback(
    (node) => {
      // Don't observe if loading or no more data
      if (loadingData || !hasMore || list.length < 5) return;

      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            handlePageChange();
          }
        },
        { root: null, rootMargin: "100px", threshold: 0.1 }
      );

      if (node) observerRef.current.observe(node);
    },
    [loadingData, hasMore, list.length]
  );
  const imgURLs = MY_PROFILE_COMMUNITY;
  const imgURL = MY_PROFILE_COMMUNITY_POST;

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: sliderImages.length > 1, // Disable infinite scrolling if only one image
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    beforeChange: (current, next) => setActiveImageIndex(next),
  };

  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const handleThumbnailClick = (index) => {
    setActiveImageIndex(index);
  };

  const handleOpenSlider = (images) => {
    setSliderImages(images);
    setIsSliderOpen(true);
  };

  const handleCloseSlider = () => {
    setIsSliderOpen(false);
  };

  const handleDelete = (id) => {
    swal({
      text: "Are you sure you want to delete this post?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: true,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
      dangerMode: true,
      closeOnClickOutside: false,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(Delete_post(id))
          .then((response) => {
            if (response?.success) {
              swal("", "Post Deleted successfully", "success");
            }
          })
          .then(() => {
            setPage(1);
            setList([]);
            fetchPosts(1); // Re-fetch posts
          });
      }
    });
  };

  const HandleLike = (e) => {
    // Set the current post ID as being liked
    setLikeInProgress(e._id);

    const userrole =
      localStorage.getItem("Role_user_Auth") == 2 ? "admin" : "super_admin";
    const Likes = {
      post_id: e?._id,
      user_id: localStorage.getItem("User_specific_id"),
      user_type: userrole,
    };

    dispatch(CommunityPost_Like(Likes)).then((response) => {
      if (response?.success) {
        setList((prevList) =>
          prevList.map((post) => {
            if (post._id === e._id) {
              return {
                ...post,
                like_count: (post.like_count || 0) + 1,
                is_liked: true,
              };
            }
            return post;
          })
        );
        // Clear the like in progress after a short delay
        setTimeout(() => {
          setLikeInProgress(null);
        }, 1000);
      }
    });
  };

  const unLike = (e) => {
    const Likes = {
      post_id: e?._id,
      user_id: localStorage.getItem("User_specific_id"),
    };

    dispatch(CommunityPost_UnLike(Likes)).then((response) => {
      if (response?.success) {
        setList((prevList) =>
          prevList.map((post) => {
            if (post._id === e._id) {
              return {
                ...post,
                like_count: Math.max((post.like_count || 0) - 1, 0),
                is_liked: false, // Update is_liked status
              };
            }
            return post;
          })
        );
      }
    });
  };

  const refreshPosts = useCallback(() => {
    // Reset to first page and clear existing posts
    setPage(1);
    setList([]);
    fetchPosts(1);
  }, []);

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header d-flex align-items-center justify-content-between py-3 w-100">
                  <div className="d-flex align-items-center">
                    {console.log(state?.image, "state?.image")}
                    <img src={imgURLs + state?.image} className="profile-img" />
                    <h6 className="ms-2 mb-0 font-weight-bold text-primary">
                      {state?.name}
                    </h6>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="mb-3">
                      <Link
                        to={{
                          pathname: "/viewMembers",
                          state: state?._id, // Pass the data here
                        }}
                      >
                        <button className="btn btn-primary me-3">
                          View Members
                        </button>
                      </Link>
                    </div>
                    <div className="mb-3">
                      <ModalPostCommunity
                        id={state?._id}
                        onPostCreated={refreshPosts}
                        style={{ marginTop: "1.9rem" }}
                      />
                    </div>
                  </div>
                </div>
                

                {list?.length == 0 ? (
                  <p className="mb-3 mt-3 text-center"> No posts found </p>
                ) : (
                  list.map((post, index) => (
                    <div
                      key={post._id}
                      className="card-body"
                      ref={index === list.length - 1 ? lastPostRef : null}
                    >
                      

                      <div className="card com-post-card-new shadow mb-4">
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div className="profile-name-img">
                              <div className="d-flex align-items-center">
                                <img
                                  className="profile-img"
                                  src={`${MY_PROFILE}/${post?.user_details?.profile_image}`}
                                  // src={`${imgURL}${post?.user_details?.profile_image}`}
                                />
                                <h6 className="ms-2 mb-0 font-weight-bold text-primary">
                                  {post?.user_details?.firstname
                                    ? post?.user_details?.firstname
                                    : "Rater Admin"}
                                </h6>
                              </div>
                            </div>
                          </div>
                          <div
                            className="delet-icon cursor-pointerr"
                            onClick={() => handleDelete(post?._id)}
                          >
                            <i className="fas fa-trash"></i>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="image-gallery">
                            {post.images.slice(0, 4).map((image, index) => (
                              <div
                                key={index}
                                className={`image-item me-2 ${
                                  index === 3 ? " image-item me-2 more" : ""
                                }`}
                                onClick={() =>
                                  handleOpenSlider(
                                    post.images.map((image) => {
                                      const fullUrl = imgURL + image.trim();
                                      return fullUrl;
                                    })
                                  )
                                }
                              >
                                <img
                                  src={`${imgURL}${image}`}
                                  alt="Post"
                                  className="post-img cursor-pointerr"
                                />
                                <div className="overlay cursor-pointerr">
                                  +1
                                </div>
                              </div>
                            ))}

                            {post?.images.length > 4 && (
                              <div
                                className="image-item"
                                onClick={() =>
                                  handleOpenSlider(
                                    post.images.map((image) => {
                                      const fullUrl = imgURL + image.trim(); // Trim to avoid extra spaces
                                      return fullUrl; // Ensure this returns the concatenated URL
                                    })
                                  )
                                }
                              ></div>
                            )}
                            <div className="heart-overlay">
                              {likeInProgress === post._id && (
                                <img
                                  src={Heart}
                                  alt="Liked"
                                  className="heart-img"
                                />
                              )}
                            </div>
                          </div>
                          <div className="mt-3 cursor-pointerr">
                            {post.is_liked ? (
                              <span
                                onClick={() => unLike(post)}
                                style={{ color: "red", fontSize: "18px" }}
                              >
                                ❤️
                              </span>
                            ) : (
                              <span
                                onClick={() => HandleLike(post)}
                                style={{ fontSize: "18px" }}
                              >
                                🤍
                              </span>
                            )}
                            <span className="ms-1">
                              {post?.like_count ? post?.like_count : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
                {loadingData && (
                  <div className="loader-container mt-5">
                    <div className="loaders_post"></div>
                  </div>
                )}
                {!hasMore && list.length > 0 && (
                  <div className="text-center my-4">No more posts</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slider Modal */}
      {isSliderOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "80%",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: "99",
              }}
              onClick={handleCloseSlider}
            >
              ✖
            </button>

            <Slider {...sliderSettings}>
              {sliderImages &&
                sliderImages?.map((image, index) => (
                  <div key={index}>
                    <img
                      src={`${imgURL}${sliderImages[activeImageIndex]}`}
                      className={sliderImages.length === 1 ? "no-hover" : ""}
                      alt="Slider"
                      style={{
                        width: "100%",
                        height: "350px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
            </Slider>
            <div className="slider-container">
              {/* Thumbnails */}
              <div className="thumbnails-container">
                {sliderImages?.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${
                      activeImageIndex === index ? "active-thumbnail" : ""
                    }`}
                    onClick={() => handleThumbnailClick(index)}
                    style={{
                      cursor: "pointer",
                      border:
                        activeImageIndex === index
                          ? "2px solid #007BFF"
                          : "none",
                      borderRadius: "5px",
                      padding: "2px",
                    }}
                  >
                    <img
                      className="post-img"
                      src={imgURL + image}
                      alt={`Thumbnail ${index + 1}`}
                      style={{
                        width: "60px",
                        height: "60px !important",
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                    />
                    <div className="overlay">+1</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GetAllPosts;
